import { createFileRoute } from '@tanstack/react-router';

import { QrGeneratorPage } from '../modules/qr-generator/ui/pages/QrGeneratorPage';

export const Route = createFileRoute(
  '/_authenticated/super-admin/qr-generator/$orgId/$locationId/',
)({
  component: QrGeneratorPage,
  staticData: {
    breadcrumb: ['Platform', 'QR Code Generator', 'Batches'],
  },
});
